<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">

          <img :src="'https://pokemonrevolution.net/forum/avatar.php?user=' + authUser.user" alt="" class="img-avatar"/>
          <span class="d-md-down-none">{{authUser.user}} | <a class="role" :style="{color: role.colour}">{{role.name}}</a></span></template>
        <b-dropdown-item v-if="hasPermission('ToolsRestart')" @click="confirmRestartTools">
          <i class="icon-refresh"></i> Restart Tools
        </b-dropdown-item>
        <b-dropdown-item v-if="hasPermission('ToolsReloadData')" @click="confirmReloadToolsData">
          <i class="fa fa-refresh"></i> Reload Tools Data
        </b-dropdown-item>
        <b-dropdown-item v-if="hasPermission('MaintenanceToggle')" @click="confirmMaintenanceToggle">
          <i class="fa fa-wrench"></i> Maintenance:
          <span :class="[authUser.maintenance ? 'text-success' : 'text-danger', 'font-weight-bold']">{{ authUser.maintenance ? 'ON' : 'OFF' }}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import Auth from '../../Auth'
  import Roles from '../../_roles'
  import store from "@/store";
  export default {
    name: 'header-dropdown',
    computed: {
      ...mapGetters([
        'authUser'
      ]),
      role () {
        return Roles[this.authUser.security]
      }
    },
    methods: {
      ...mapActions([
        'resetPermission'
      ]),
      async confirmRestartTools () {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          'This will restart the tools UI for all connected users.',
          {
            title: 'Confirm Restart',
            okTitle: 'Restart',
            cancelTitle: 'Cancel',
            centered: true,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'dark',
            bodyTextVariant: 'light'
          }
        )
        if (confirmed) {
          this.emit('restartTools')
        }
      },
      async confirmReloadToolsData () {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          'This reloads static data cached by the tools, including form mappings, random sets, and PvP banlist data.',
          {
            title: 'Confirm Data Reload',
            okTitle: 'Reload',
            cancelTitle: 'Cancel',
            centered: true,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'dark',
            bodyTextVariant: 'light'
          }
        )
        if (confirmed) {
          this.emit('reloadToolsData')
        }
      },
      async confirmMaintenanceToggle () {
        const enable = !this.authUser.maintenance
        const confirmed = await this.$bvModal.msgBoxConfirm(
          enable
            ? 'This enables maintenance mode for users without bypass permission and refreshes connected clients.'
            : 'This disables maintenance mode and refreshes connected clients.',
          {
            title: enable ? 'Enable Maintenance' : 'Disable Maintenance',
            okTitle: enable ? 'Enable' : 'Disable',
            cancelTitle: 'Cancel',
            centered: true,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'dark',
            bodyTextVariant: 'light'
          }
        )
        if (confirmed) {
          this.emit('setMaintenanceMode', {enabled: enable})
        }
      },
      logout () {
        this.emit('logout', 0)
        Auth.logout()
        this.resetPermission()
        if (this.$socket) {
          this.$disconnect()
        }
        this.$router.push('/auth/login')
      }
    }
  }
</script>

<style scoped>
.header-user-dropdown /deep/ .dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 18px;
  transition: background-color 0.15s ease;
}
.header-user-dropdown /deep/ .dropdown-toggle:hover {
  background-color: rgba(255, 255, 255, 0.06);
}
.user-meta {
  display: inline-flex;
  flex-direction: column;
  line-height: 1.1;
}
.user-name {
  color: #d8dee4;
  font-weight: 600;
  font-size: 0.9rem;
}
.user-role {
  font-size: 0.75rem;
  opacity: 0.9;
}
.dropdown-title {
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  color: #8f9ba6;
}
.header-user-dropdown /deep/ .dropdown-menu {
  min-width: 210px;
}
</style>
